import "./Pip.css";

const COLORS = {
  body: "#FDF3E0",
  foundBody: "#F5E4C0",
  stroke: "#C4790A",
  pupil: "#0E0C0A",
};

function PipOutfitLayer({ outfit = {} }) {
  if (!outfit) return null;
  const layers = [];
  if (outfit.hat?.includes("crown") || outfit.hat?.includes("challenge_allcategories")) {
    layers.push(
      <path key="crown" d="M34 18 L44 8 L60 14 L76 8 L86 18 Z" fill="#C4790A" stroke="#8B4A00" strokeWidth="1.2" />
    );
  } else if (outfit.hat?.includes("toque")) {
    layers.push(<rect key="toque" x="38" y="8" width="44" height="18" rx="9" fill="#C0392B" stroke="#C4790A" strokeWidth="1.2" />);
  } else if (outfit.hat?.includes("beret")) {
    layers.push(<ellipse key="beret" cx="60" cy="16" rx="28" ry="10" fill="#2A1800" stroke="#C4790A" strokeWidth="1.2" />);
  } else if (outfit.hat?.includes("hockey")) {
    layers.push(<path key="helmet" d="M30 10 Q60 0 90 10 L88 28 Q60 22 32 28 Z" fill="#DDD8CE" stroke="#C4790A" strokeWidth="1.5" />);
  } else if (outfit.hat?.includes("flame") || outfit.hat?.includes("streak")) {
    layers.push(<path key="flame" d="M52 6 Q60 -4 68 6 Q64 14 60 18 Q56 14 52 6" fill="#E85D04" stroke="#C4790A" strokeWidth="1" />);
  }
  if (outfit.accessory?.includes("maple") || outfit.accessory?.includes("canadaday")) {
    layers.push(<text key="maple" x="94" y="100" style={{ fontSize: 14, fill: "#C4790A" }}>🍁</text>);
  }
  if (outfit.accessory?.includes("coffee")) {
    layers.push(<rect key="coffee" x="88" y="118" width="10" height="14" rx="2" fill="#C0392B" stroke="#C4790A" strokeWidth="1" />);
  }
  if (outfit.shirt?.includes("gold") || outfit.shirt?.includes("100finds") || outfit.shirt?.includes("founder")) {
    layers.push(<rect key="goldshirt" x="38" y="118" width="44" height="36" rx="18" fill="#E8C878" stroke="#C4790A" strokeWidth="1.8" />);
  }
  return <g className="pip-outfit">{layers}</g>;
}

function PipIdleBody({ found = false, eyeClass = "pip-eye" }) {
  const fill = found ? COLORS.foundBody : COLORS.body;
  return (
    <>
      <circle cx="60" cy="62" r="58" fill={fill} stroke={COLORS.stroke} strokeWidth="2" />
      <ellipse cx="28" cy="88" rx="13" ry="8" fill={COLORS.stroke} opacity="0.08" />
      <ellipse cx="92" cy="88" rx="13" ry="8" fill={COLORS.stroke} opacity="0.08" />
      <path d="M34 30 Q60 18 86 30" fill="none" stroke={COLORS.stroke} strokeWidth="2.2" strokeLinecap="round" />
      <ellipse cx="60" cy="66" rx="28" ry="30" fill="white" stroke={COLORS.stroke} strokeWidth="1.8" />
      <circle cx="60" cy="66" r="18" fill={COLORS.stroke} className={eyeClass} />
      <circle cx="60" cy="66" r="10" fill={COLORS.pupil} />
      <circle cx="67" cy="57" r="5" fill="white" opacity="0.95" />
      <circle cx="52" cy="72" r="2.2" fill="white" opacity="0.45" />
      <path d="M50 76 Q60 82 70 76" fill="none" stroke={fill} strokeWidth="1.5" strokeLinecap="round" opacity="0.55" />
      <path d="M48 104 Q60 110 72 104" fill="none" stroke={COLORS.stroke} strokeWidth="1.8" strokeLinecap="round" />
      <rect x="38" y="118" width="44" height="36" rx="18" fill={fill} stroke={COLORS.stroke} strokeWidth="1.8" />
      <ellipse cx="24" cy="134" rx="12" ry="7" fill={fill} stroke={COLORS.stroke} strokeWidth="1.5" transform="rotate(-12 24 134)" />
      <ellipse cx="96" cy="134" rx="12" ry="7" fill={fill} stroke={COLORS.stroke} strokeWidth="1.5" transform="rotate(12 96 134)" />
      <rect x="44" y="150" width="12" height="18" rx="6" fill={fill} stroke={COLORS.stroke} strokeWidth="1.5" />
      <rect x="64" y="150" width="12" height="18" rx="6" fill={fill} stroke={COLORS.stroke} strokeWidth="1.5" />
      <ellipse cx="50" cy="168" rx="10" ry="5.5" fill={fill} stroke={COLORS.stroke} strokeWidth="1.5" />
      <ellipse cx="70" cy="168" rx="10" ry="5.5" fill={fill} stroke={COLORS.stroke} strokeWidth="1.5" />
    </>
  );
}

function PipWaveBody() {
  return (
    <>
      <circle cx="60" cy="62" r="58" fill={COLORS.body} stroke={COLORS.stroke} strokeWidth="2" />
      <ellipse cx="28" cy="88" rx="13" ry="8" fill={COLORS.stroke} opacity="0.08" />
      <ellipse cx="92" cy="88" rx="13" ry="8" fill={COLORS.stroke} opacity="0.08" />
      <path d="M32 26 Q60 12 88 26" fill="none" stroke={COLORS.stroke} strokeWidth="2.5" strokeLinecap="round" />
      <ellipse cx="60" cy="62" rx="30" ry="32" fill="white" stroke={COLORS.stroke} strokeWidth="1.8" />
      <circle cx="60" cy="59" r="19" fill={COLORS.stroke} />
      <circle cx="60" cy="59" r="11" fill={COLORS.pupil} />
      <circle cx="68" cy="50" r="5.5" fill="white" opacity="0.95" />
      <circle cx="52" cy="65" r="2.2" fill="white" opacity="0.45" />
      <path d="M50 72 Q60 78 70 72" fill="none" stroke={COLORS.body} strokeWidth="1.5" strokeLinecap="round" opacity="0.55" />
      <path d="M44 100 Q60 112 76 100" fill="none" stroke={COLORS.stroke} strokeWidth="2.2" strokeLinecap="round" />
      <rect x="36" y="116" width="44" height="36" rx="18" fill={COLORS.body} stroke={COLORS.stroke} strokeWidth="1.8" />
      <ellipse cx="22" cy="132" rx="12" ry="7" fill={COLORS.body} stroke={COLORS.stroke} strokeWidth="1.5" transform="rotate(-12 22 132)" />
      <g className="pip-wave-arm-live">
        <path d="M80 118 C96 98 108 76 100 58" fill="none" stroke={COLORS.stroke} strokeWidth="2.4" strokeLinecap="round" />
        <circle cx="98" cy="52" r="10" fill={COLORS.body} stroke={COLORS.stroke} strokeWidth="1.8" />
      </g>
      <rect x="44" y="148" width="12" height="18" rx="6" fill={COLORS.body} stroke={COLORS.stroke} strokeWidth="1.5" />
      <rect x="60" y="148" width="12" height="18" rx="6" fill={COLORS.body} stroke={COLORS.stroke} strokeWidth="1.5" />
      <ellipse cx="50" cy="166" rx="10" ry="5.5" fill={COLORS.body} stroke={COLORS.stroke} strokeWidth="1.5" />
      <ellipse cx="66" cy="166" rx="10" ry="5.5" fill={COLORS.body} stroke={COLORS.stroke} strokeWidth="1.5" />
      <text x="110" y="60" className="pip-sparkle-text pip-sparkle-1">✦</text>
      <text x="120" y="78" className="pip-sparkle-text pip-sparkle-2">✦</text>
      <text x="104" y="44" className="pip-sparkle-text pip-sparkle-3">✦</text>
    </>
  );
}

function PipFoundBody() {
  return (
    <>
      <circle cx="60" cy="62" r="74" fill="#FEF8EE" stroke={COLORS.stroke} strokeWidth="0.8" strokeDasharray="3 3" opacity="0.6" />
      <circle cx="60" cy="62" r="58" fill={COLORS.foundBody} stroke={COLORS.stroke} strokeWidth="2.2" />
      <ellipse cx="26" cy="92" rx="15" ry="9" fill={COLORS.stroke} opacity="0.14" />
      <ellipse cx="94" cy="92" rx="15" ry="9" fill={COLORS.stroke} opacity="0.14" />
      <path d="M28 20 Q60 4 92 20" fill="none" stroke={COLORS.stroke} strokeWidth="2.8" strokeLinecap="round" />
      <ellipse cx="60" cy="66" rx="30" ry="33" fill="white" stroke={COLORS.stroke} strokeWidth="2" />
      <circle cx="60" cy="66" r="20" fill={COLORS.stroke} />
      <text x="60" y="75" textAnchor="middle" className="pip-found-star">✦</text>
      <circle cx="68" cy="52" r="5" fill="white" opacity="0.7" />
      <path d="M36 106 Q60 122 84 106" fill="none" stroke={COLORS.stroke} strokeWidth="2.6" strokeLinecap="round" />
      <rect x="36" y="120" width="48" height="38" rx="20" fill={COLORS.foundBody} stroke={COLORS.stroke} strokeWidth="2" />
      <path d="M36 132 C18 108 8 88 20 74" fill="none" stroke={COLORS.stroke} strokeWidth="2.8" strokeLinecap="round" />
      <circle cx="18" cy="69" r="10" fill={COLORS.foundBody} stroke={COLORS.stroke} strokeWidth="1.8" />
      <path d="M84 132 C102 108 112 88 100 74" fill="none" stroke={COLORS.stroke} strokeWidth="2.8" strokeLinecap="round" />
      <circle cx="102" cy="69" r="10" fill={COLORS.foundBody} stroke={COLORS.stroke} strokeWidth="1.8" />
      <rect x="44" y="154" width="12" height="18" rx="6" fill={COLORS.foundBody} stroke={COLORS.stroke} strokeWidth="1.8" />
      <rect x="64" y="154" width="12" height="18" rx="6" fill={COLORS.foundBody} stroke={COLORS.stroke} strokeWidth="1.8" />
      <ellipse cx="50" cy="172" rx="10" ry="5.5" fill={COLORS.foundBody} stroke={COLORS.stroke} strokeWidth="1.8" />
      <ellipse cx="70" cy="172" rx="10" ry="5.5" fill={COLORS.foundBody} stroke={COLORS.stroke} strokeWidth="1.8" />
      <text x="-4" y="110" className="pip-sparkle-text pip-sparkle-1">✦</text>
      <text x="118" y="104" className="pip-sparkle-text pip-sparkle-2">✦</text>
      <text x="16" y="128" className="pip-sparkle-text pip-sparkle-3">✦</text>
      <text x="106" y="126" className="pip-sparkle-text pip-sparkle-4">✦</text>
    </>
  );
}

function PipPeekA() {
  return (
    <>
      <circle cx="70" cy="110" r="72" fill={COLORS.body} stroke={COLORS.stroke} strokeWidth="2" />
      <ellipse cx="34" cy="128" rx="14" ry="9" fill={COLORS.stroke} opacity="0.08" />
      <ellipse cx="106" cy="128" rx="14" ry="9" fill={COLORS.stroke} opacity="0.08" />
      <path d="M38 58 Q70 44 102 58" fill="none" stroke={COLORS.stroke} strokeWidth="2.2" strokeLinecap="round" />
      <ellipse cx="70" cy="88" rx="32" ry="34" fill="white" stroke={COLORS.stroke} strokeWidth="1.8" />
      <circle cx="70" cy="84" r="21" fill={COLORS.stroke} />
      <circle cx="70" cy="84" r="12" fill={COLORS.pupil} />
      <circle cx="78" cy="74" r="6" fill="white" opacity="0.95" />
      <circle cx="61" cy="91" r="2.5" fill="white" opacity="0.45" />
      <path d="M56 108 Q70 116 84 108" fill="none" stroke={COLORS.stroke} strokeWidth="2" strokeLinecap="round" />
      <rect x="0" y="112" width="140" height="8" rx="4" fill="#EDE9E2" stroke="#DDD8CE" strokeWidth="1" />
      <rect x="26" y="105" width="11" height="16" rx="5.5" fill={COLORS.body} stroke={COLORS.stroke} strokeWidth="1.6" />
      <rect x="42" y="105" width="11" height="16" rx="5.5" fill={COLORS.body} stroke={COLORS.stroke} strokeWidth="1.6" />
      <rect x="86" y="105" width="11" height="16" rx="5.5" fill={COLORS.body} stroke={COLORS.stroke} strokeWidth="1.6" />
      <rect x="102" y="105" width="11" height="16" rx="5.5" fill={COLORS.body} stroke={COLORS.stroke} strokeWidth="1.6" />
    </>
  );
}

function PipPeekB() {
  return (
    <>
      <circle cx="70" cy="130" r="72" fill={COLORS.body} stroke={COLORS.stroke} strokeWidth="2" />
      <path d="M36 36 Q70 22 104 36" fill="none" stroke={COLORS.stroke} strokeWidth="2.2" strokeLinecap="round" />
      <ellipse cx="70" cy="66" rx="32" ry="34" fill="white" stroke={COLORS.stroke} strokeWidth="1.8" />
      <circle cx="70" cy="58" r="21" fill={COLORS.stroke} />
      <circle cx="70" cy="58" r="12" fill={COLORS.pupil} />
      <circle cx="78" cy="49" r="6" fill="white" opacity="0.95" />
      <circle cx="61" cy="64" r="2.5" fill="white" opacity="0.45" />
      <rect x="0" y="70" width="140" height="10" rx="4" fill="#EDE9E2" stroke="#DDD8CE" strokeWidth="1" />
      {[14, 28, 42, 78, 92, 106].map((x) => (
        <rect key={x} x={x} y="62" width="10" height="16" rx="5" fill={COLORS.body} stroke={COLORS.stroke} strokeWidth="1.6" />
      ))}
    </>
  );
}

function PipPeekC() {
  return (
    <>
      <rect x="8" y="0" width="8" height="150" rx="4" fill="#EDE9E2" stroke="#DDD8CE" strokeWidth="1" />
      <circle cx="28" cy="75" r="72" fill={COLORS.body} stroke={COLORS.stroke} strokeWidth="2" />
      <ellipse cx="70" cy="90" rx="14" ry="9" fill={COLORS.stroke} opacity="0.08" />
      <path d="M18 30 Q54 16 86 30" fill="none" stroke={COLORS.stroke} strokeWidth="2.2" strokeLinecap="round" />
      <ellipse cx="62" cy="74" rx="30" ry="32" fill="white" stroke={COLORS.stroke} strokeWidth="1.8" />
      <circle cx="56" cy="72" r="20" fill={COLORS.stroke} />
      <circle cx="52" cy="72" r="11" fill={COLORS.pupil} />
      <circle cx="56" cy="62" r="5.5" fill="white" opacity="0.95" />
      <circle cx="46" cy="78" r="2" fill="white" opacity="0.45" />
      <path d="M38 100 Q58 112 76 100" fill="none" stroke={COLORS.stroke} strokeWidth="2" strokeLinecap="round" />
      <rect x="3" y="54" width="14" height="10" rx="5" fill={COLORS.body} stroke={COLORS.stroke} strokeWidth="1.5" />
      <rect x="3" y="70" width="14" height="10" rx="5" fill={COLORS.body} stroke={COLORS.stroke} strokeWidth="1.5" />
      <rect x="3" y="86" width="14" height="10" rx="5" fill={COLORS.body} stroke={COLORS.stroke} strokeWidth="1.5" />
    </>
  );
}

const VIEWBOX = {
  idle: "0 0 120 160",
  wave: "-10 0 160 170",
  found: "-10 -20 150 200",
  peekA: "0 0 140 120",
  peekB: "0 0 140 80",
  peekC: "0 0 120 150",
};

// Idle body is drawn in a 120×160 viewBox. Every pose keeps that unit scale so
// wider frames (wave arm) grow outside a fixed slot instead of shrinking Pip.
const BASE_VB_WIDTH = 120;
const BASE_VB_HEIGHT = 160;

function resolveVisualState(state, peek) {
  if (state === "peek" || state.startsWith("peek")) {
    const v = peek || state.replace("peek", "") || "A";
    return `peek${v.toUpperCase()}`;
  }
  if (state === "found") return "found";
  if (state === "wave") return "wave";
  return "idle";
}

function parseViewBox(vb) {
  const parts = String(vb).split(/\s+/).map(Number);
  return {
    minX: parts[0] || 0,
    minY: parts[1] || 0,
    width: parts[2] || BASE_VB_WIDTH,
    height: parts[3] || BASE_VB_HEIGHT,
  };
}

export default function PipCharacter({
  size = 80,
  state = "idle",
  peek = "A",
  outfit = null,
  className = "",
  style = {},
  interactive = false,
  animClass = "",
}) {
  const visual = resolveVisualState(state, peek);
  const vb = VIEWBOX[visual] || VIEWBOX.idle;
  const { minX, minY, width: vbW, height: vbH } = parseViewBox(vb);
  const unit = size / BASE_VB_WIDTH;
  const svgWidth = vbW * unit;
  const svgHeight = vbH * unit;
  const slotW = size;
  const slotH = size * (BASE_VB_HEIGHT / BASE_VB_WIDTH);

  let body;
  if (visual === "wave") body = <PipWaveBody />;
  else if (visual === "found") body = <PipFoundBody />;
  else if (visual === "peekA") body = <PipPeekA />;
  else if (visual === "peekB") body = <PipPeekB />;
  else if (visual === "peekC") body = <PipPeekC />;
  else body = <PipIdleBody found={false} />;

  const stateClass =
    visual === "idle" ? "pip-idle" :
    visual === "found" ? "pip-found" :
    visual === "wave" ? "pip-wave-state" :
    visual.startsWith("peek") ? "pip-peek" : "";

  return (
    <span
      className={`pip-character ${stateClass} ${interactive ? "pip-interactive" : ""} ${animClass} ${className}`}
      style={{
        display: "inline-block",
        position: "relative",
        width: slotW,
        height: slotH,
        overflow: "visible",
        flexShrink: 0,
        ...style,
      }}
      aria-hidden={!interactive}
    >
      <svg
        width={svgWidth}
        height={svgHeight}
        viewBox={vb}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        style={{
          position: "absolute",
          left: -minX * unit,
          top: slotH - (vbH + minY) * unit,
          width: svgWidth,
          height: svgHeight,
          maxWidth: "none",
          maxHeight: "none",
          overflow: "visible",
        }}
      >
        {body}
        <PipOutfitLayer outfit={outfit} />
      </svg>
    </span>
  );
}

export { PipCharacter as Pip };
